import { updateSubscription } from 'app/shared/flux/actions/MarketingActions';
import constants from 'app/shared/flux/constants';
import type { MarketUpdateStatusErrorType, MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';
import { logError } from '@zg-rentals/log-error';

const serverRouteWillMount = ({ store }: { store: any }) => {
  const { dispatch } = store;
  const { query, queryString, pathname } = store.getState().router.location;
  const { email, marketUpdateId, enabled = false } = query;
  return (
    dispatch(updateSubscription({ email: decodeURIComponent(email), enabled, marketUpdateId }))
      // @ts-ignore
      .then((res: MarketUpdateStatusType) => {
        const { marketUpdateEnabled, streetAddress } = res;
        const { street, state, city, zip, unit, hasUnitLabel } = streetAddress;
        const formattedAddress = `${street} ${hasUnitLabel ? unit : ''}, ${city}, ${state} ${zip}`;
        dispatch({
          type: constants.SET_UNSUBSCRIBE_RESULT,
          payload: { success: true, address: formattedAddress, isSubscribed: marketUpdateEnabled },
        });
        return;
      })
      .catch((err: MarketUpdateStatusErrorType) => {
        logError({
          error: err,
          errorType: 'Subscription',
          context: {
            details: 'Unsubscribe Page: Error updating subscription',
            root: 'pages/UnsubscribePage#useEffect',
            pathAttempted: pathname,
            queryAttempted: queryString,
          },
        });
        dispatch({
          type: constants.SET_UNSUBSCRIBE_RESULT,
          payload: { success: false },
        });
      })
  );
};

export default serverRouteWillMount;
